import { render, staticRenderFns } from "./NewPosts.vue?vue&type=template&id=6e9854fc&scoped=true&"
import script from "./NewPosts.vue?vue&type=script&lang=js&"
export * from "./NewPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9854fc",
  null
  
)

export default component.exports